var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59563",
    "data-name": "Rectangle 59563",
    width: 96,
    height: 96,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61540",
    "data-name": "Group 61540",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61539",
    "data-name": "Group 61539",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136460",
    "data-name": "Path 136460",
    d: "M96,48A48,48,0,1,1,48,0,48,48,0,0,1,96,48",
    transform: "translate(0 -0.001)",
    fill: "#00a64c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136461",
    "data-name": "Path 136461",
    d: "M35.6,60.7,11.587,38.734a3.6,3.6,0,1,1,4.86-5.312l18.29,16.735L62.49,14.948a3.6,3.6,0,0,1,5.654,4.457Z",
    transform: "translate(8.333 10.862)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.12b7098d8de2762bd0b5d9cbe0f43ea2.svg";
export { ForwardRef as ReactComponent };